import { WcsPromotion } from '@/scripts/interfaces/normalizer'
import { WcsFrameAdvisorProduct } from '@/types/frame-genius'
import { getBestBetweenTwoPromos, sortPromos } from '@/scripts/libs/sort-promos'
import { EYEGLASSES, SUN, SUNGLASSES } from '@/scripts/constants/pdp'
import { RAY_BAN } from '@/scripts/constants/store'
import { Product as StoreProduct } from '@/types/pdp'
import { getColorForRoxPanel, getModelForRoxPanel } from '@/scripts/libs/frame-genius'

export class RxcConfig {
  static isWcsFrameAdvisorProduct(product: any): product is WcsFrameAdvisorProduct {
    return (
      typeof product.klarnaEnabled !== 'undefined' &&
      typeof product.roxFrameCatentryId === 'string' &&
      typeof product.colorCategory === 'string'
    )
  }

  static mapRxcConfig = (product: StoreProduct) => {
    const normalizedProduct = product

    const listPrice = normalizedProduct.prices?.listPrice
    const promotions = sortPromos(normalizedProduct.promotions)
    const currentPromo = getBestBetweenTwoPromos(promotions)

    console.log('FRAME', normalizedProduct.roxFrameCatEntryId)
    console.log('product', product)
    console.log('NORMALIZED PRODUCT', normalizedProduct)

    const sizeLabel =
      normalizedProduct.sizes?.find((item) => item.catEntryId === product.catEntryId) || ({} as any)

    return {
      frame: {
        catEntryId: normalizedProduct.catEntryId,
        roxFrameCatentryId: normalizedProduct.roxFrameCatEntryId,
        name: normalizedProduct.modelName,
        upc: normalizedProduct.partNumber,
        listPrice,
        offerPrice: currentPromo?.price,
        category: normalizedProduct.type === SUN ? SUNGLASSES : EYEGLASSES,
        brand: RAY_BAN,
        imageUrl: normalizedProduct.imageUrl,
        rxValues: normalizedProduct.prescriptionThresholds,
        size: sizeLabel?.size,
        model: getModelForRoxPanel(normalizedProduct.moCo),
        color: getColorForRoxPanel(normalizedProduct.moCo),
        currency: normalizedProduct.prices.currencySymbol,
      },
      brand: 'rayban',
      lens: {
        colorCategory: normalizedProduct.features?.lenses?.colorCategory,
        clen: normalizedProduct.clen,
      },
      klarnaEnabled: normalizedProduct.klarna.enabled,
      klarnaInstallments: normalizedProduct.klarna.installments || 0,
    }
  }
}
